/* eslint-disable
    consistent-return,
    no-cond-assign,
    no-return-assign,
    no-shadow,
    no-unused-vars,
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import DOMPurify from 'dompurify';
import {marked} from 'marked';
import _ from 'underscore';

import {assert, assertAndContinue} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import notifications from 'notifications';
import preferences from 'Preferences';
import * as analytics from 'analytics/Analytics';
import {NavTutorialForNewUsers} from 'nav/NavTutorial';

function notifyTutorialEnd() {
  notifications.info('End the tutorial to start using Benchling.', {id: 'tutorial-end'});
}

class Step extends Backbone.Model {
  defaults() {
    return {
      include: true,
      events: {},
      showNext: false,
      before: null,
      clickBefore: null,
      showSequenceMap: false,
      showGoldenGatePrimers: false,
      showNotes: false,
      showNewEntryProtocol: false,
      modal: null,
      animation: true,
      wait: null,
      start: null,
      overlay: false,
      overlayed: [],
      overlayPaddingLeft: 0,
      overlayPaddingRight: 0,
      overlayPaddingTop: 0,
      overlayPaddingBottom: 0,
      includeTargetMargin: true,
      scrollTo: null,
      scrollPaddingTop: 100,
      overlayColor: null,
      scrollDelay: 1000,
      forceHome: false,
      preventEarlyEnd: false,
      clearOverlay: false,
      title: null,
    };
  }

  include() {
    const value = this.get('include');
    if (_.isFunction(value)) {
      return value();
    } else {
      return value;
    }
  }

  renderContent() {
    const content = _(this.attributes).result('content');
    return DOMPurify.sanitize(marked(content));
  }
}

class Tour extends Backbone.Collection {
  static initClass() {
    this.prototype.model = Step;
  }

  initialize() {
    return (this.stepNum = 0);
  }

  next(cid) {
    let index;
    if (cid != null) {
      index = this.indexOf(this.get(cid)) + 1;
    } else {
      index = 0;
    }

    for (let i = index; i < this.length; i++) {
      const step = this.at(i);
      this.stepNum++;
      if (step.include()) {
        return step;
      }
    }
    return null;
  }
}
Tour.initClass();

class TourView extends Backbone.View {
  static initClass() {
    this.prototype.el = 'body';
  }

  initialize({showRevisitMessage, onFinish}) {
    this.showRevisitMessage = showRevisitMessage;
    this.onFinish = onFinish;
    this.handleBackBtn = this.handleBackBtn.bind(this);
    this.defaultEvents = {
      'click .js-help-exit-early': 'kill',
      'click .js-help-done': 'finish',
    };
    this.stepTotal = this.collection.length;
    this.alive = true;
    this.step = null;
    this.showRevisitMessage = this.showRevisitMessage || false;

    // Ideally, if the user changes the route from the expected tour route, we should abort the tutorial.
    // There are two ways to do this: 1. navigating via the history buttons (popstate), 2. interacting with
    // the site that causes the site to route (pushstate). Some of our tours span multiple URLs, so it is
    // expected for pushstate to occur (note: we happen to only use silent URL syncing in tours, so
    // technically there is no pushstate, but is something that we should not rely on). Because the tour uses
    // overlays to prevent the user from leaving the tutorial unexpectedly, we only need to check for history
    // button navigation.
    window.addEventListener('popstate', this.handleBackBtn);
  }

  handleBackBtn() {
    this.kill();
  }

  next() {
    this.removeOldState();
    if (this.step != null ? this.step.has('next') : undefined) {
      this.step.get('next').apply(this);
    }
    if (this.step != null) {
      analytics.track('onboarding_tour', 'advanced', {
        tour: 'navigation',
        tourOrigin: 'checklist_sidepanel',
        numberOfSteps: 6,
        stepNumber: this.step.get('forceCount') + 1,
        stepTitle: this.step.get('title'),
        object: 'button',
        objectText: this.step.get('showNext') ? 'Next' : 'Get Started!',
        eventLastModified: 'FY21_Q1a2',
      });
    }
    this.step = this.collection.next(this.step != null ? this.step.cid : undefined);
    this.undelegateEvents();
    if (this.step != null) {
      if (this.step.get('start') != null) {
        this.step.get('start').apply(this);
      }
      const openStep = () => {
        let main, placement, top;
        if (this.step.get('before') != null) {
          this.step.get('before').apply(this);
        }
        if (this.step.has('scrollTo')) {
          const $scrollTo = $(this.step.get('scrollTo'));
          if ($scrollTo.length === 0) {
            assertAndContinue(false, `Tutorial step failed: ${this.step.get('content')}`);
            return;
          }
          top = $(this.step.get('scrollTo')).offset().top - this.step.get('scrollPaddingTop');
          $('body').stop(true).animate({scrollTop: top}, this.step.get('scrollDelay'));
        }
        if (this.step.get('options') != null) {
          // eslint-disable-next-line no-restricted-syntax
          const option = _.find(this.step.get('options'), (info) => $(info.target)[0] != null);
          this.step.set('target', option.target);
          this.step.set('content', _(option).result('content'));
        }

        if (this.step.get('html')) {
          main = this.step.get('content');
        } else {
          main = $('<p>').html(this.step.renderContent());
        }

        const content = $('<div>').addClass('help-popover').append(main);
        const count = this.step.get('forceCount') || this.collection.stepNum;
        const total = this.step.get('forceTotal') || this.stepTotal;

        let nextButtonClass, nextButtonText;
        const navTourCtas = $('<div>').addClass('u-vertical-center-items u-lr-split');
        const dots = $('<div>');
        if (!this.step.get('introStep')) {
          for (let i = 1; i < total + 1; i++) {
            const dot = $('<div>').addClass('navTour-dot');
            if (i === count) {
              dot.addClass('is-active');
            }
            dots.append(dot);
          }
        }
        navTourCtas.append(dots);
        if (count === total) {
          nextButtonClass = 'button button--medium button--primary js-help-done';
          nextButtonText = 'Get Started!';
        } else {
          nextButtonClass = 'button button--medium button--primary continue';
          nextButtonText = count === 0 ? "Let's Go!" : 'Next';
        }
        const nextButton = $('<button type="button">').addClass(nextButtonClass).text(nextButtonText);
        navTourCtas.append(nextButton);
        content.append(navTourCtas);

        const events = _.clone(this.defaultEvents);
        // eslint-disable-next-line no-restricted-syntax
        this.delegateEvents(_.extend(events, this.step.get('events')));
        if (this.step.get('showNext') && count !== total) {
          events['click .continue'] = 'next';
        }

        this.delegateEvents(events);

        let tabStateClass = null;
        const FileStates = require('FileStates').default;
        if (this.step.get('showSequenceMap')) {
          tabStateClass = require('molbio/tabstates/SequenceLinearMapTabState').default;
        } else if (this.step.get('showGoldenGatePrimers')) {
          const GoldenGateTabState = require('assembly/tabs/GoldenGateTabState').default;
          tabStateClass = GoldenGateTabState;
        } else if (this.step.get('showNotes')) {
          const NoteTabState = require('notebook/notes/tabs/NoteTabState').default;
          tabStateClass = NoteTabState;
        } else if (this.step.get('showNewEntryProtocol')) {
          tabStateClass =
            require('notebook/entries/backbone/tabs/NewEntryProtocolTab').NewEntryProtocolTabState;
        } else {
          tabStateClass = null;
        }

        if (tabStateClass != null) {
          let bufferIndex;
          const splitButton = $('#statusbar button.split');
          if (!splitButton.hasClass('active')) {
            splitButton.click();
          }
          const fileState = FileStates.get().findWhere({active: true});
          const tab = fileState.findTab(tabStateClass);
          if (tab == null) {
            assertAndContinue(false, `Tutorial step failed: ${this.step.get('content')}`);
            return;
          }
          tab.set({active: true});
          const buffers = fileState.buffers();
          const firstTabs = buffers.at(0).tabs();
          if (firstTabs.contains(tab)) {
            placement = 'right';
            bufferIndex = 1;
          } else {
            placement = 'left';
            bufferIndex = 2;
          }
          this.target = $(`.buffer-container:nth-child(${bufferIndex})`);
        } else {
          this.target = this.$el.find(this.step.get('target'));
          if (this.step.get('first') != null) {
            this.target = this.target.first();
          }
          placement = this.step.get('placement');
        }

        content.toggleClass('kill-on-split', tabStateClass != null);
        if (this.step.get('overlay')) {
          const stepTarget = this.target;
          if (stepTarget.length === 0) {
            assertAndContinue(false, `Tutorial step failed: ${this.step.get('content')}`);
            return;
          }
          // eslint-disable-next-line no-restricted-syntax
          this.step.createOverlays = _.bind(function () {
            let height, left, positions, width;
            $(`.${this.cid}`).remove();
            const overallWidth = $(document).width();
            const overallHeight = $(document).height();
            if (window.test_user) {
              positions = [[0, 0, overallWidth, overallHeight, 'transparent']];
            } else {
              positions = [];
            }

            let emptyLeft = overallWidth;
            let emptyRight = 0;
            let emptyTop = overallHeight;
            let emptyBottom = 0;
            // eslint-disable-next-line no-restricted-syntax
            const overlayed = _.map(this.get('overlayed'), (t) => $(t));
            const showMargin = this.get('includeTargetMargin');
            for (const $target of Array.from(overlayed.concat([stepTarget]))) {
              const rowPos = $target.offset();
              assert(
                rowPos != null,
                `Tutorial step failed: ${this.get('content')} ($target.offset() undefined)`
              );
              ({top} = rowPos);
              ({left} = rowPos);
              width = $target.outerWidth(showMargin);
              height = $target.outerHeight(showMargin);
              emptyLeft = Math.min(emptyLeft, left);
              emptyRight = Math.max(emptyRight, left + width);
              emptyTop = Math.min(emptyTop, top);
              emptyBottom = Math.max(emptyBottom, top + height);
            }

            emptyLeft -= this.get('overlayPaddingLeft');
            emptyRight += this.get('overlayPaddingRight');
            emptyTop -= this.get('overlayPaddingTop');
            emptyBottom += this.get('overlayPaddingBottom');
            positions = positions.concat([
              [0, 0, overallWidth, emptyTop, this.get('overlayColor')],
              [emptyTop, 0, emptyLeft, emptyBottom - emptyTop, this.get('overlayColor')],
              [
                emptyTop,
                emptyRight,
                overallWidth - emptyRight,
                emptyBottom - emptyTop,
                this.get('overlayColor'),
              ],
              [emptyBottom, 0, overallWidth, overallHeight - emptyBottom, this.get('overlayColor')],
            ]);
            if (this.get('clearOverlay')) {
              positions.push([emptyTop, emptyLeft, emptyRight - emptyLeft, emptyBottom - emptyTop, null, 0]);
            }
            return (() => {
              const result = [];
              for (const position of Array.from(positions)) {
                const [bottomTop, bottomLeft, bottomWidth, bottomHeight, overlayColor, overlayOpacity] =
                  Array.from(position);
                const $divOverlay = $('<div>')
                  .addClass('overlay')
                  .addClass(this.cid)
                  .click((e) => {
                    e.stopPropagation();
                    notifyTutorialEnd();
                  });

                $divOverlay.css({
                  position: 'absolute',
                  top: bottomTop,
                  left: bottomLeft,
                  width: bottomWidth,
                  height: bottomHeight,
                });

                if (overlayColor != null) {
                  $divOverlay.css('background-color', overlayColor);
                }
                if (overlayOpacity != null) {
                  $divOverlay.css('opacity', overlayOpacity);
                }
                result.push($('body').prepend($divOverlay));
              }
              return result;
            })();
          }, this.step);
          this.step.createOverlays();
          $(window).on('resize', this.step.createOverlays);
          $(document).on(`keydown.${this.step.cid}`, () => {
            notifyTutorialEnd();
            return false;
          });
        }
        return _.defer(() => {
          let left;
          const modalSelector = this.step.get('modal');
          const showPopover = (modalSelector) => {
            const container = modalSelector != null ? modalSelector : 'body';
            this.target.popover({
              placement,
              content: $('<div>').html(content).html(),
              html: true,
              trigger: 'manual',
              container,
              title: (left = this.step.get('title')) != null ? left : `Step ${count} of ${total}`,
              animation: this.step.get('animation'),

              // Specify this to insert js-tutorial-popover as a class in the outer div.
              template: (() => {
                const popoverClass = `popover js-tutorial-popover navTour ${this.step.get(
                  'extraPopoverClass'
                )}`;
                const closeClass = count === total ? 'js-help-done' : 'js-help-exit-early';
                const popoverTitle = '<div class="popover-title navTour-title"></div>';
                return `\
<div class='${popoverClass}' role='tooltip'>
  ${this.step.get('hideArrow') ? '<div></div>' : '<div class="arrow"></div>'}
  <div class='navTour-header u-lr-split'>
    ${this.step.get('hideTitle') ? '<div></div>' : popoverTitle}
    <div class='navTour-close ${closeClass}'>
      <svg class="navTour-close-svgIcon">
        <use
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xlink:href="#close_00bb7a61634e1d067e6c089c38aaad07"
        >
        </use>
      </svg>
    </div>
  </div>
  <div class='popover-content navTour-content'></div>
</div>\
`;
              })(),
            });
            this.target.popover('show');

            if (modalSelector != null) {
              // make z-index higher than bootstrap's one for modals
              return $(modalSelector).find('.popover').css('z-index', 1060);
            }
          };

          if (modalSelector != null) {
            showPopover(modalSelector);
          } else {
            showPopover();
          }

          if (this.step.has('top')) {
            $('.popover').css({top: this.step.get('top')});
          }
          if (this.step.has('left')) {
            $('.popover').css({left: this.step.get('left')});
          }
          if (this.step.has('class')) {
            return $('.popover').addClass(this.step.get('class'));
          }
        });
      };
      if (this.step.has('wait')) {
        return $(this.step.get('wait')).promise().done(openStep);
      } else if (this.step.has('waitPromise')) {
        return this.step.get('waitPromise')().done(openStep);
      } else {
        return openStep();
      }
    } else {
      return this.remove();
    }
  }

  removeOldState() {
    if (this.step != null) {
      this.target.popover('destroy');
      this.target.data('bs.popover', null);

      if (this.step.get('overlay')) {
        $(`.${this.step.cid}`).remove();
        if (this.step.createOverlays) {
          $(window).off('resize', this.step.createOverlays);
        }
        return $(document).off(`keydown.${this.step.cid}`);
      }
    }
  }

  finish() {
    if (typeof this.onFinish === 'function') {
      this.onFinish();
    }
    this.kill();
    if (this.step != null) {
      analytics.track('onboarding_tour', 'advanced', {
        tour: 'navigation',
        tourOrigin: 'checklist_sidepanel',
        numberOfSteps: 6,
        stepNumber: this.step.get('forceCount') + 1,
        stepTitle: this.step.get('title'),
        object: 'button',
        objectText: this.step.get('showNext') ? 'Next' : 'Get Started!',
        eventLastModified: 'FY21_Q1a2',
      });
    }
  }

  kill(isUserInitiated = true) {
    if (this.step != null ? this.step.has('kill') : undefined) {
      this.step.get('kill').apply(this);
    }
    if (isUserInitiated) {
      analytics.track('onboarding_tour', 'closed', {
        tour: 'navigation',
        tourOrigin: 'checklist_sidepanel',
        numberOfSteps: 6,
        stepNumber: this.step.get('forceCount') + 1,
        stepTitle: this.step.get('title'),
        object: 'button',
        objectText: 'X',
        eventLastModified: 'FY21_Q1a2',
      });
    }
    this.removeOldState();
    if (this.showRevisitMessage) {
      notifications.info(
        "If you'd like to revisit a tutorial, you can find it by opening the help page from the top right corner."
      );
    }
    this.undelegateEvents();
    this.remove();
    return (this.alive = false);
  }

  remove() {
    // bound to body, don't want to remove el from page
    // probably should namespace this so other body events
    // don't get wiped
    this.stopListening();
    window.removeEventListener('popstate', this.handleBackBtn);
    return this;
  }
}
TourView.initClass();

export {Tour, TourView};
